module.exports = __webpack_public_path__ + "static/media/weighbridge.f52583cb.jpg";